const body = document.body;

const openModal = () => {
  const scrollY = window.scrollY;

  body.dataset.scrollLockY = String(scrollY);

  body.style.position = "fixed";
  body.style.top = `-${scrollY}px`;
  body.style.left = "0px";
  body.style.right = "0px";
};

const closeModal = () => {
  const scrollY = Number(body.dataset.scrollLockY || 0);

  body.style.position = "";
  body.style.top = "";
  body.style.left = "";
  body.style.right = "";
  delete body.dataset.scrollLockY;

  window.scrollTo(0, scrollY);
};

export { openModal, closeModal };
